<template>
	<div class="center_main_goods_box">
		<el-row :gutter="20">
			<el-col :span="6" v-for="(item,index) in center_mian_goods" :key="index">
				<div :class="[
				        'center-goods-box',
				        {'hover-box': enter_index === index}
				    ]" @mouseenter="handleMove(index)" @mouseleave="handleMove(-1)">
					<center-goods-list :goods="item">
					</center-goods-list>
					<!-- 收藏按钮 -->
					<div v-if="power.includes(17) || power.includes(0) || power.includes(111)" :class="[
				            'center-goods-collection',
				            {'is-collection':item.collection>0}
				        ]">
						<a href="javascript:;" @click="handleCollection(item)">
							<i class="glyphicon glyphicon-heart-empty"></i>
						</a>
					</div>
				</div>
			</el-col>
		</el-row>
		<!-- 属性选择模态框 -->
		<get-attr></get-attr>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from "vuex";

	export default {
		data() {
			return {
				enter_index: -1
			}
		},
		computed: mapState({
			center_mian_goods: state => state.goods.center_mian_goods,
			power: state => state.user.power,
		}),
		components: {
			centerGoodsList: () => import("@/components/center/centerGoodsList"),
			getAttr: () => import("@/components/getAttr"),
		},
		methods: {
			...mapActions([
			    "requestCollection"
			]),
			...mapMutations([
			    "handleUserGoodsCollection"
			]),
			handleMove(val) {
				this.enter_index = val;
			},
			handleCollection(goods){ // 收藏操作
				// console.log(goods)
			    let { goods_id, goods_sn, goods_name } = goods;
			    this.requestCollection({
			        goods_id,
			        goods_sn,
			        goods_name
			    }).then((res) => {
			        if(res == 1){
						goods.collection = 1
			            this.$message({
			                showClose: true,
			                message: this.$t("message.plist.collection3"),
			                type: 'success'
			            })
			        }else if(res == 3){
						goods.collection = null
			            this.$message({
			                showClose: true,
			                message: this.$t("message.plist.collection4"),
			                type: 'success'
			            })
			        }
			    })
			}
		}
	}
</script>

<style scoped>
	/* 商品盒子 */
	.center-goods-box{
	    position: relative;
	}
	.hover-box>.center-goods-collection{
	    z-index: 3;
	    opacity: 0.8;
	}
	.hover-box>.center-goods-collection:hover{
	    background: #ff6700;
	}
	/* 收藏盒子 */
	.center-goods-collection{
	    position: absolute;
	    top: 15px;
	    right: 15px;
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	    background-color: #909399;
	    opacity: 0;
	    transition: all 0.2s linear;
	    z-index: -1;
	}
	.center-goods-collection>a{
	    position: absolute;
	    top: 50%;
	    left:50%;
	    transform: translate(-50%,-50%);
	    display: block;
	    color: #fff;
	}
	.center-goods-collection i{
	    line-height: normal;
	    font-size: 30px;
	}
	/* 已收藏样式 */
	.is-collection{
	    background-color: transparent !important;
	    opacity: 1;
	    z-index: 100;
	}
	.is-collection>a{
	    color: #ff6700;
	}
	
</style>
